import React, { useEffect, useState, useRef } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import HeaderAssociado from "../components/headerAssociado";
import { useAuth } from "../hooks/AuthContext";
import { Layout, Button, Modal } from "antd";
import { Content } from "antd/es/layout/layout";
import api from "../services/api";
import { toast } from "react-toastify";

const RouteAssociados = () => {
  const { user, editUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const [showContract, setShowContract] = useState(false);
  const [canAccept, setValidAccept] = useState(false);

  useEffect(() => {
    if (!user) {
      window.location.assign("/associado/login");
      return;
    }

    const type = user.type;

    if (type !== "associado") {
      if (type === "cliente") {
        window.location.assign("/cliente/home");
      } else if (type === "tecnico") {
        window.location.assign("/tecnico/home");
      } else if (type === "atendente") {
        window.location.assign("/atendente/home");
      } else {
        window.location.assign("/admin/home");
      }
      return;
    }

    if (user && !user.terms_accepted) {
      setShowContract(true);
    }
  }, [user]);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 20) {
      setValidAccept(true);
    }
  };

  const handleAccept = async () => {
    await api
      .put("/associate", {
        terms_accepted: true,
      })
      .then((response) => {
        editUser({ user: response.data });
        setShowContract(false);
        toast.success("Contrato aceito com sucesso");
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  };

  const navItems = [
    { path: "/associado/home", label: "Relatórios" },
    { path: "/associado/leads", label: "Meus Leads" },
    { path: "/associado/pagamentos", label: "Meus Pagamentos" },
    { path: "/associado/perfil", label: "Meu Perfil" },
  ];

  return user && user.type === "associado" ? (
    <Layout
      style={{
        minHeight: "100vh",
        backgroundColor: "#fff",
        filter: showContract ? "blur(5px)" : "none",
        transition: "filter 0.3s",
      }}
    >
      <HeaderAssociado />
      <Content style={{ padding: "20px 40px", backgroundColor: "#fff" }}>
        <div style={{ maxWidth: 1300, margin: "0 auto" }}>
          {!showContract && (
            <div
              style={{
                display: "flex",
                gap: 15,
                marginBottom: 30,
                borderBottom: "1px solid #f0f0f0",
                paddingBottom: 20,
                justifyContent: "center",
              }}
            >
              {navItems.map((item) => (
                <Button
                  key={item.path}
                  type={location.pathname === item.path ? "primary" : "default"}
                  style={{
                    borderRadius: 50,
                    height: 40,
                    padding: "0 35px",
                    fontWeight: "bold",
                    backgroundColor:
                      location.pathname === item.path ? "#008037" : "#fff",
                    borderColor: "#008037",
                    color: location.pathname === item.path ? "#fff" : "#008037",
                    boxShadow:
                      location.pathname === item.path
                        ? "0 4px 10px rgba(0, 128, 55, 0.2)"
                        : "none",
                  }}
                  onClick={() => navigate(item.path)}
                >
                  {item.label}
                </Button>
              ))}
            </div>
          )}
          <Outlet />
        </div>
      </Content>

      <Modal
        title="Termo de Adesão e Compromisso - Associado Guruseg"
        open={showContract}
        footer={[
          <Button
            key="submit"
            type="primary"
            disabled={!canAccept}
            onClick={handleAccept}
            style={{
              backgroundColor: canAccept ? "#008037" : "#ccc",
              borderColor: canAccept ? "#008037" : "#ccc",
              borderRadius: 50,
              padding: "0 30px",
              height: 40,
            }}
          >
            EU LI E ACEITO OS TERMOS
          </Button>,
        ]}
        closable={false}
        maskClosable={false}
        centered
        width={750}
      >
        <div
          onScroll={handleScroll}
          style={{
            height: "450px",
            overflowY: "auto",
            padding: "30px",
            background: "#fff",
            borderRadius: "10px",
            color: "#333",
            lineHeight: "1.8",
            textAlign: "justify",
            fontFamily: "serif",
            border: "1px solid #eee",
          }}
        >
          <p>
            <strong>PARCEIRA INDICADORA (CONTRATANTE):</strong>{" "}
            {user.name.toUpperCase()}
            {user.cnpj && `, inscrito no CNPJ nº ${user.cnpj}`}
            {user.state && ` com sede em ${user.city} - ${user.state}`}
          </p>

          <p>
            <strong>PARTE EXECUTORA: (CONTRATADA)</strong> GURUSEG FRANCHISING
            EM SEGURANÇA DO TRABALHO LTDA, inscrita no CNPJ sob o n.
            46.316.746/0001-00, com sede social localizada Q ACSV SE 92, AV. LO
            23, LOTE 19 SALA 01, CEP. 77.023-392, PLANO DIRETOR SUL, PALMAS,
            ESTADO DO TOCANTINS, representado pelo seu sócio LEONARDO DE SENA
            FERREIRA, Brasileiro, administrador CPF nº 017.463.051-42.
          </p>

          <p>
            <strong>CLÁUSULA 1 – DO OBJETO</strong>
            <br />O presente contrato tem como objeto a formalização de parceria
            estratégica na área de Segurança e Saúde no Trabalho (SST), com foco
            em elaboração dos laudos, envios dos eventos SST e todos serviços
            oferecidos pela Contratada em conformidade legal. A parceria
            funcionará da seguinte forma:
          </p>
          <p style={{ paddingLeft: "20px" }}>
            I – A PARCEIRA INDICADORA realizará a indicação de empresas
            interessadas nos serviços de SST.
            <br />
            II – A GURUSEG será responsável pela abordagem comercial,
            qualificação técnica, diagnóstico de necessidades legais, elaboração
            de propostas, execução técnica dos serviços e gestão documental.
          </p>

          <p>
            <strong>CLÁUSULA 2 – DOS SERVIÇOS ABRANGIDOS</strong>
            <br />A Guruseg poderá prestar aos clientes indicados, entre outros:
          </p>
          <ul style={{ listStyleType: "none", paddingLeft: "20px" }}>
            <li>• PGR – Programa de Gerenciamento de Riscos (NR-01)</li>
            <li>• LTCAT</li>
            <li>• PCMSO</li>
            <li>• AEP – Análise Ergonômica Preliminar (NR-17)</li>
            <li>• Laudos Técnicos de Insalubridade e Periculosidade</li>
            <li>• Treinamentos obrigatórios</li>
            <li>• Gestão e envio dos eventos de SST ao e-Social</li>
            <li>• E outros serviços oferecidos</li>
          </ul>

          <p>
            <strong>CLÁUSULA 3 – DA REMUNERAÇÃO DA PARCEIRA</strong>
            <br />A PARCEIRA INDICADORA fará jus a comissão de 10 a 20% sobre os
            valores líquidos efetivamente recebidos pela GURUSEG referentes aos
            contratos firmados com clientes por ela indicados.
          </p>
          <p style={{ paddingLeft: "20px" }}>
            §1º O pagamento será realizado até o dia 25 do mês subsequente ao
            recebimento do cliente.
            <br />
            §2º A comissão será devida enquanto o contrato permanecer ativo.
            <br />
            §3º Em caso de inadimplência, a comissão será devida após o efetivo
            pagamento.
            <br />
            §4º Os valores recebidos pela GURUSEG das vendas dos serviços em SST
            indicados pelo ASSOCIADO servirá também para bonificar com desconto
            exclusivo a taxa de Franquia da GURUSEG.
            <br />
            §5º Essa transição de INDICADOR para FRANQUEADO se dará após a
            GURUSEG receber em serviços indicados o número igual ou superior a
            da taxa da Franquia.
          </p>

          <p>
            <strong>CLÁUSULA 4 – DA CONFIDENCIALIDADE</strong>
            <br />
            As partes comprometem-se a manter sigilo sobre estratégias
            comerciais, precificação, metodologias técnicas e base de clientes.
          </p>

          <p>
            <strong>CLÁUSULA 5 – DA INEXISTÊNCIA DE VÍNCULO</strong>
            <br />
            Este contrato não estabelece vínculo empregatício ou societário
            entre as partes, tratando-se de parceria comercial autônoma.
          </p>

          <p>
            <strong>CLÁUSULA 6 – PRAZO E RESCISÃO</strong>
            <br />O presente contrato terá prazo de vigência, mantendo-se ativo
            por consentimentos de ambas partes podendo ser rescindido por ambas
            partes sem ressarcimento ou multas. Permanecerão devidas as
            comissões referentes aos contratos firmados durante a vigência da
            parceria.
          </p>

          <p>
            <strong>CLÁUSULA 7 – DO FORO</strong>
            <br />
            AS PARTES elegem em comum acordo o presente contrato, as partes
            elegem o Foro da Comarca de Palmas, Estado de Tocantins, com
            expressa renúncia a qualquer outro, por mais privilegiado que seja.
          </p>

          <p>
            E por estarem justos e acordados, as partes qualificadas acima
            aceitam e firmam o presente acordo, consubstanciado com a assinatura
            das testemunhas indicadas abaixo, que também poderá ser assinado
            através da assinatura eletrônica, a qual é amparada em conformidade
            com a Medida Provisória 983 de 2020 e Medida Provisória nº
            2.200-2/2001, a qual surte seus efeitos legais garantidos pela
            autenticidade certificada pela plataforma de assinatura eletrônica
            DOCSALES OU ASSINESEG, a qual emite para ambas as partes uma via do
            presente instrumento com a certidão de certificado da assinatura
            eletrônica.
          </p>

          <p>
            E, por estarem assim justas e acordadas, as partes firmam este
            instrumento em 3 (três) vias de igual teor e forma, na presença das
            2 (duas) testemunhas abaixo assinadas.
          </p>
        </div>
      </Modal>
    </Layout>
  ) : null;
};

export default RouteAssociados;
